// extracted by mini-css-extract-plugin
export default {"container":"styles__container___73LV5"};